import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://upcorestag.aio-synergy.tech/' // Replace with your base URL
});

export default instance;
